import { render, staticRenderFns } from "./BroadPicture.vue?vue&type=template&id=c5ff5b12&scoped=true"
import script from "./BroadPicture.vue?vue&type=script&lang=js"
export * from "./BroadPicture.vue?vue&type=script&lang=js"
import style0 from "./BroadPicture.vue?vue&type=style&index=0&id=c5ff5b12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ff5b12",
  null
  
)

export default component.exports